<template>
    <div class="notfound">
        页面找不到
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
    .notfound{
        font-size: 16rem;
    }
</style>